import { formData, CheckDACH, setErrorReceived, ErrorMessage, responseData, setLicenseNumber, setLicenseState, setDriverDOB, uiState, setDriverLastName, readHistoryCache, cacheHistory, getErrorMessage } from '../../utils/data';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PrintPage from '../PrintPage';
import Loading from '../Loading';
import { useAuth } from '../../context/AuthContext';
import AddressTable from '../tables/addressTable';
import AliasTable from '../tables/aliasTable';
import EndorsementsTable from '../tables/endorsementsTable';
import HazmatTable from '../tables/hazmatTable';
import MedicalCertTable from '../tables/medcertTable';
import RestrictionTable from '../tables/restrictionsTable';
import PermitTables from '../tables/permitTable';
import { createLog } from '../datawriter/createLog';
import "../print.css"

function HistoryResponse() {
    const [testData, setTestData] = useState({});
    const [loading, setLoading] = useState(true);
    const [requestID, setRequestID ]= useState();
    const [errorMessage, setErrorMessage] = useState([]);
    console.log("Data form: ", formData);
    const navigate = useNavigate();
    const location = useLocation();
    const fromAkaMinimal = location.state?.fromAkaMinimal;
    const licenseOnly = location.state?.licenseOnly;
    const histKey = `${formData.Body.DriverRequest.DriverLicense.LicenseState}/${formData.Body.DriverRequest.DriverLicense.LicenseNumber}`;
    const { token, email } = useAuth();

    console.log(email)
    useEffect(() => {
        console.log("From AKA:", fromAkaMinimal);
        const cached = readHistoryCache(histKey);
        if (cached) {
          setErrorMessage(cached.messages);
          setTestData(cached.response);
          setRequestID(cached.transactionID);
          setLoading(false);
          return;
        }
        const fetchData = async () => {
          try {
            await responseData('/api/history', token, 'history', { licenseOnly })
            .then(function (response) {
                createLog(response,email);
                if(response?.Response?.DriverDetails !== undefined) {
                    setErrorMessage(response.Messages)
                    setTestData(response);
                    console.log("Completed:",response);
                    setRequestID(response.TransactionGUID);
                    cacheHistory({ key: histKey, response });
                    setLoading(false);
                } else {
                    setErrorReceived(response.Messages.length > 0 ? response.Messages : ["ERROR: Database Unavailable"]);
                    if (fromAkaMinimal) {
                        response.Messages !== undefined ? setErrorReceived(response.Messages) : setErrorReceived(["ERROR: Database Unavailable."]);
                        // setLoading(false);
                        // return;
                    }
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error("E: "+error)
                setErrorReceived(["ERROR: Database Unavailable."]);
                if (fromAkaMinimal) {
                    setErrorMessage(["ERROR: Database Unavailable."]);
                    // setLoading(false);  // stop spinner and render error-only screen
                    // return;
                }
                navigate(-1);
            })
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived(["ERROR: Database Unavailable."]);
            if (fromAkaMinimal) {
                setErrorMessage(["ERROR: Database Unavailable."]);
                // setLoading(false);  // stop spinner and render error-only screen
                // return;
            }
            navigate(-1);
          }
          
        };
    
        fetchData();
    }, []);
    
    if(loading){
        return(<>
            <Loading />
            </>)
    }
    // If we failed and we're staying here (from AKA), show the error-only view

    if (Object.keys(testData).length === 0 && fromAkaMinimal) {
        
      return (
        <>
          <div id='print-area'>
            {errorMessage.map((m) => (<ErrorMessage value={m} />))}
            <div id='table'>
              <div style={{ fontSize:'small', width:'fit-content', background:'white' }}>
                <div id="banner-results">
                  <h4>History Search Results</h4>
                  <h6>
                    <span>/{formData.Body.DriverRequest.DriverLicense.LicenseState}/{formData.Body.DriverRequest.DriverLicense.LicenseNumber}</span>
                    {/* no requestID since the call failed */}
                  </h6>
                </div>
                {/* You can add any brief note here if you want */}
              </div>
            </div>
            {/* <div style={{ display:'flex', gap:'0.5rem' }}>
              <a href='/akaresults'><button type="button" className="btn btn-primary" id="button">Back to AKA Results</button></a>
            </div> */}
          </div>
        </>
      );
    }
    return(
        <>
        <div id='print-area'>
        
        <CheckDACH dach={testData.Response.DACH_Status}/>
        
        {errorMessage.map((message => (
            <ErrorMessage value={message} />
        )))}
        
            <div id='table'>
                
            <div style={{ fontSize:'small', width: 'fit-content', background: 'white'}}>
                <div id="banner-results">
                <h4>History Search Results</h4>
                <h6>
                <span>/{formData.Body.DriverRequest.DriverLicense.LicenseState}/{formData.Body.DriverRequest.DriverLicense.LicenseNumber}</span>
                    <span style={{float: 'right' }}>{requestID}</span>
                </h6>
                </div><th>Driver General Information</th>
                <table className="table table-striped table-bordered">
                
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.FirstName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.MiddleName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.SurName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.Suffix}</td>
                    </tr>
                </tbody>
                </table>
                <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        {formData.Body.DriverRequest.DriverLicense.LicenseState === 'MX' &&

                        <><th scope="col">CURP</th>
                        <th scope="col">RFC</th></>}
                        <th scope="col">SSN</th>
                        <th scope="col">Date of Birth</th>
                        <th scope="col">Height</th>
                        <th scope="col">Weight</th>
                        <th scope="col">Eye Color</th>
                        <th scope="col">Sex</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.SSN}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.DOB}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Height}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Weight}</td>
                        {testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1] ? <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1]}</td>: <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor}</td>}
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Sex}</td>
                    </tr>
                </tbody>
                </table>
                <div>
                
                    <AddressTable label="Residence Address" address={testData.Response.DriverDetails.PersonDetails.ResidenceAddress}/>
                    <AddressTable label="Mailing Address" address={testData.Response.DriverDetails.PersonDetails.MailingAddress}/>
                    <AliasTable alias={testData.Response.DriverDetails.Alias}/>
                </div>
                <th>Driver License Details</th>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Jurisdiction</th>
                            <th scope="col">Driver License</th>
                            <th scope="col">Issue Date</th>
                            <th scope="col">Expiration Date</th>
                            <th scope="col">Commercial Class</th>
                            <th scope="col">Commercial Status</th>
                            <th scope="col">Non Commercial Class</th>
                            <th scope="col">Non Commercial Status</th>
                            <th scope="col">Withdrawal Action Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{testData.Response.DriverDetails.License.JurisdictionOfIssue}</td>
                            <td>{testData.Response.DriverDetails.License.LicenseNumber}</td>
                            <td>{testData.Response.DriverDetails.License.IssueDate}</td>
                            <td>{testData.Response.DriverDetails.License.ExpirationDate ?? testData.Response.DriverDetails.License.ExpiryDate}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.WithdrawalActionPending.split('-')[1]}</td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <EndorsementsTable endorsements={testData.Response.DriverDetails.Endorsements}/>
                    <HazmatTable hazmat={testData.Response.DriverDetails.HazMatEndorsement}/>
                    <MedicalCertTable medCert={testData.Response.DriverDetails.MedicalCertificate}
                    medName={testData.Response.DriverDetails.MedicalExaminerName}
                    med={testData.Response.DriverDetails.MedicalExaminer}
                    medRest={testData.Response.DriverDetails.MedicalCertificateRestrictionCode}/>
                    <RestrictionTable restrictions={testData.Response.DriverDetails.Restrictions}/>
                    <PermitTables permits={testData.Response.DriverDetails.Permits}/>
                    
                </div>
                <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Convictions</th>
                        <th scope="col">Accidents</th>
                        <th scope="col">Withdrawals</th>
                        <th scope="col">Permits</th>
                        <th scope="col">License Restrictions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord ? <td>{testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Convictions?.length}</td> }
                        {testData.Response.DriverDetails.License.TotalAccidentsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalAccidentsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Accidents?.length}</td> }
                        {testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord}</td> : <td>{testData?.Response?.DriverDetails?.Withdrawals?.length}</td> }
                        {testData.Response.DriverDetails.License.NumberOfPermits ? <td>{testData.Response.DriverDetails.License.NumberOfPermits}</td> : <td>{testData?.Response?.DriverDetails?.Permits?.length}</td> }
                        {testData.Response.DriverDetails.License.NumberOfRestrictions ? <td>{testData.Response.DriverDetails.License.NumberOfRestrictions}</td> : <td>{testData?.Response?.DriverDetails?.Restrictions?.length}</td> }
                    </tr>
                </tbody>
                </table>
                <div>
                    <CheckConvictions convictions={testData.Response.DriverDetails.Convictions} />
                    <CheckAccidents accidents={testData.Response.DriverDetails.Accidents} />
                    <CheckWithdrawals withdrawals={testData.Response.DriverDetails.Withdrawals} />
                </div></div>
            </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
            <PrintPage
            type="history"
            response={testData.Response}
            queryLine={`/${formData.Body.DriverRequest.DriverLicense.LicenseState}/${formData.Body.DriverRequest.DriverLicense.LicenseNumber}`}
            transactionID={requestID}
            messages={errorMessage}
            />

         </div>
         </div></>
    );
}
function CheckConvictions({convictions}) {
    if(convictions !== undefined && convictions !== null && convictions.length > 0) {
        return(
       <><th>Convictions</th><table className="table table-striped table-bordered" >
            <thead>
                <tr>
                    <th scope="col">Citation Date</th>
                    <th scope="col">Conviction Date</th>
                    <th scope="col">Conviction ID</th>
                    <th scope="col">State of Conviction</th>
                    <th scope="col">Court Type</th>
                    <th scope="col">ACD Code</th>
                    <th scope="col">ACD Details</th>
                    <th scope="col">CDL Holder</th>
                    <th scope="col">CMV</th>
                    <th scope="col">Hazmat</th>
                    <th scope="col">Locator Ref.</th>
                    <th scope="col">State Code</th>

                </tr>
            </thead>
            <tbody>
                {convictions.map((details => (
                    <tr>
                        <td>{details.CitationDate}</td>
                        <td>{details.ConvictionDate}</td>
                        <td>{details.ConvictionIdCode}</td>
                        <td>{details.JurisdictionCodeConvicting}</td>
                        {details.ConvictionCourtType !== "" && details.ConvictionCourtType.split('-')[1] ? <td>{details.ConvictionCourtType.split('-')[1]}</td> : <td>{details.ConvictionCourtType}</td>}

                        <td>{details.ConvictionOffenseAcdCode.Code} - {details.ConvictionOffenseAcdCode.Description}</td>
                        <td>{details.ConvictionOffenseDetailAcd}</td>
                        {details.CitationCdlHolderIndicator !== "" && details.CitationCdlHolderIndicator.split('-')[1] ? <td>{details.CitationCdlHolderIndicator.split('-')[1]}</td> : <td>{details.CitationCdlHolderIndicator}</td>}
                        {details.ConvictionCommercialVehInd !== "" && details.ConvictionCommercialVehInd.split('-')[1] ? <td>{details.ConvictionCommercialVehInd.split('-')[1]}</td> : <td>{details.ConvictionCommercialVehInd}</td>}
                        {details.ConvictionHazmatInd !== "" && details.ConvictionHazmatInd.split('-')[1] ? <td>{details.ConvictionHazmatInd.split('-')[1]}</td> : <td>{details.ConvictionHazmatInd}</td>}

                        <td>{details.ConvictionJurisCourtReportId}</td>
                        <td>{details.ConvictionJurisdictionOffenseCode}</td>
                    </tr>
                )))}
            </tbody>
        </table></> 
        )
    } return
}
function CheckWithdrawals({withdrawals}) {
    if(withdrawals !== undefined && withdrawals !== null && withdrawals.length > 0) {
        return(
        <><th>Withdrawals</th><table className="table table-striped table-bordered" >
            <thead>
                <tr>
                    <th scope="col">Effective Date</th>
                    <th scope="col">Eligibility Date</th>
                    <th scope="col">Rein. Date</th>
                    <th scope="col">Withdrawal ID</th>
                    <th scope="col">Linkage</th>
                    <th scope="col">Action</th>
                    <th scope="col">ACD Code</th>
                    <th scope="col">State</th>
                    <th scope="col">Basis</th>
                    <th scope="col">Extent</th>
                    <th scope="col">Locator Ref.</th>
                    <th scope="col">Reason Ref Code</th>
                    <th scope="col">Due Process Status</th>
                </tr>
            </thead>
            <tbody>
                {withdrawals.map((details => (
                    <tr>
                        <td>{details.DriverLicenseWithdrawalEffectiveDate}</td>
                        <td>{details.DRVLicWithdrawalEligibilityDate}</td>
                        <td>{details.DLWithdrawalReinstatementDate}</td>
                        <td>{details.DriverLicenseWithdrawalIdCode}</td>
                        <td>{details.DLWithdrawalIdConvictionLinksGroup}</td>
                        <td>{details?.DriverLicenseWithdrawalType?.split('-')[1]}</td>
                        {details?.DRVLicAcdWithdrawalReasonCode?.Code ? <td>{details.DRVLicAcdWithdrawalReasonCode.Code} - {details.DRVLicAcdWithdrawalReasonCode.Description} </td> : <td></td>}
                        <td>{details.JurisdictionCodeWithdrawing}</td>
                        <td>{details?.DriverLicenseWithdrawalBasis?.split('-')[1]}</td>
                        <td>{details?.DRVLicWithdrawalExtentIdDlc?.split('-')[1]}</td>
                        <td>{details.DRVLicWithdrawalReasonReference}</td>
                        <td>{details.DLWithdrawalJurisdictionReportId}</td>
                        <td>{details?.DLWithdrawalDueProcessStatus?.split('-')[1]}</td>
                    </tr>
                )))}
            </tbody>
        </table></>
        )
    } return
    
}
function CheckAccidents({accidents}) {
    if(accidents !== undefined && accidents !== null && accidents.length > 0) {
        return(
            <><th>Accidents</th><table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Accident Date</th>
                        <th scope="col">State</th>
                        <th scope="col">Severity</th>
                        <th scope="col">Driving CMV</th>
                        <th scope="col">Carrying Hazmat</th>
                        <th scope="col">Locator Reference</th>
                    </tr>
                </thead>
                <tbody>
                    {accidents.map((details => (
                        <tr>
                            <td>{details.AccidentDate}</td>
                            <td>{details.AccidentJurisdictionCode}</td>
                            <td>{details.AccidentSeverityCode}</td>
                            <td>{details.DriverAccidentCommercialVehInd}</td>
                            <td>{details.DriverAccidentHazmatInd}</td>
                            <td>{details.AccidentLocatorReference}</td>
                        </tr>
                    )))}
                </tbody>
            </table></>
        )
    } return
}
export default HistoryResponse;